import React from 'react';
import styled from 'styled-components';
import { OutboundLink } from 'gatsby-plugin-google-analytics'

import { facebookShareUrl, twitterShareUrl } from "../util";
import facebook from '../images/facebook.svg';
import twitter from '../images/twitter.svg';

const SocialStyled = styled.ul`
  display: flex;

  ${({ center }) => center && `
    justify-content: center;
  `}

  li {
    flex: 0 0 34px;
    height: 34px;
    width: 34px;

    &:first-child {
      margin-right: 21px;
    }
  }

  a {
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: 70% auto;
    display: block;
    height: inherit;
    text-indent: -9999px;
  }

  .facebook {
    background-image: url(${facebook});
  }

  .twitter {
    background-image: url(${twitter});
  }

  ${({ mobileSmall }) => mobileSmall && `
    @media (max-width: 767px) {
      display: inline-block;
      padding: 0 !important;

      li {
        display: inline-block;
        height: 18px;
        width: 18px;

        &:first-child {
          margin-right: 10px;
        }
      }
    }
  `}
`

const Social = ({ url, shareDescription, ...props }) => (
  <SocialStyled {...props}>
    <li>
      <OutboundLink className="facebook" target="_blank" href={facebookShareUrl(url)}>Facebook</OutboundLink>
    </li>
    <li>
      <OutboundLink className="twitter" target="_blank" href={twitterShareUrl(url, shareDescription)}>Twitter</OutboundLink>
    </li>
  </SocialStyled>
);

export default Social;
